<template>
	<!--    <van-popup v-model="show" overlay-class="container">-->
	<div class="container">
		<div v-if="!loading" style="width: 100%; margin: 0px auto; margin-top: 10px; text-align: left">
			<van-field
				v-model="formModel.name"
				clearable
				:label="ticketTitleNameText"
				label-align="left"
				:label-width="currentLang === 'en' ? '7em' : '5em'"
				:placeholder="namePlaceholder"
				required></van-field>
			<van-field
				v-model="formModel.taxNumber"
				clearable
				:label="ticketTaxNumberText"
				:label-width="currentLang === 'en' ? '7em' : '5em'"
				:placeholder="taxNumberPlaceholder"
				label-align="left"
				required></van-field>
			<van-field
				v-model="formModel.address"
				clearable
				:placeholder="addressPlaceholder"
				label-align="left"
				:label-width="currentLang === 'en' ? '7em' : '5em'"
				:label="ticketCampanyAddressText"></van-field>
			<van-field
				v-model="formModel.tele"
				clearable
				label-align="left"
				:label-width="currentLang === 'en' ? '7em' : '5em'"
				:placeholder="telPlaceholder"
				:label="ticketCampanyTelText"></van-field>
			<van-field
				v-model="formModel.depositBank"
				label-align="left"
				:label-width="currentLang === 'en' ? '9em' : '5em'"
				clearable
				:placeholder="bankPlaceholder"
				:label="ticketCampanyBankNameText"></van-field>
			<van-field
				v-model="formModel.bank"
				clearable
				:placeholder="bankNumPlaceholder"
				:label-width="currentLang === 'en' ? '8em' : '5em'"
				label-align="left"
				:label="ticketCampanyBankNumText"></van-field>
			<div class="flex-form-queue" style="margin-top: 30px">
				<mobile-button color="#005423" class="btn-font" @click="add" style="width: 40%; text-align: center">
					{{ addText }}
				</mobile-button>
				<mobile-button color="#005423" class="btn-font" @click="cancel" style="width: 40%; text-align: center">
					{{ resetText }}
				</mobile-button>
			</div>
		</div>
		<pre-page v-if="!loading" :title="returnText" @back="back"></pre-page>
		<van-loading color="#005423" v-else style="min-height: 200px; line-height: 200px" />
	</div>
	<!--    </van-popup>-->
</template>
<script>
import MobileButton from 'components/mobile-button/index'
import apiPayTicket from 'api/pay-ticket'
import prePage from 'components/pre-page/index'
import db from '@/utils/db'

export default {
	// props: {
	//     show: {
	//         type: Boolean,
	//         default: false,
	//     },
	// },
	name: 'ticketAddDialog',
	components: { MobileButton, prePage },
	computed: {
		currentLang() {
			return db.get('sys.public.language.value').value() || 'zh'
		}
	},
	data() {
		return {
			ticketTitleNameText: this.$t('pay_ticket.name'),
			namePlaceholder: this.$t('pay_ticket.name_placeholder'),
			ticketTaxNumberText: this.$t('pay_ticket.organ_model.taxNumber'),
			taxNumberPlaceholder: this.$t('pay_ticket.organ_model.taxNumber_placeholder'),
			ticketCampanyAddressText: this.$t('pay_ticket.organ_model.address'),
			addressPlaceholder: this.$t('pay_ticket.organ_model.address_placeholder'),
			ticketCampanyTelText: this.$t('pay_ticket.organ_model.tele'),
			telPlaceholder: this.$t('pay_ticket.organ_model.tele_placeholder'),
			ticketCampanyBankNameText: this.$t('pay_ticket.organ_model.depositBank'),
			bankPlaceholder: this.$t('pay_ticket.organ_model.depositBank_placeholder'),
			ticketCampanyBankNumText: this.$t('pay_ticket.organ_model.bank'),
			bankNumPlaceholder: this.$t('pay_ticket.organ_model.bank_placeholder'),
			addText: this.$t('pay_ticket.add'),
			resetText: this.$t('pay_ticket.reset'),
			returnText: this.$t('pay_ticket.pre_page'),
			show: false,
			search: '',
			loading: false,
			formModel: {
				ticketIds: '',
				name: '',
				taxNumber: '',
				address: '',
				tele: '',
				depositBank: '',
				bank: '',
				titleType: 2
			}
		}
	},
	methods: {
		handle(startTime) {
			this.$nextTick(() => {
				let t = 800 - (new Date() - startTime)
				if (t > 0) {
					setTimeout(() => {
						this.loading = false
					}, t)
				} else {
					this.loading = false
				}
			})
		},
		onShow() {
			this.show = true
		},
		onClose() {
			this.show = false
		},
		back() {
			// this.$router.back()
			this.$emit('back')
		},
		cancel() {
			this.reset()
		},
		add() {
			let startTime = new Date()
			this.loading = true
			let param = this.formModel
			apiPayTicket
				.ticketUpdate(param)
				.then(res => {
					this.$emit('select', param)
					this.reset()
				})
				.catch(err => {
					this.loading = false
				})
			this.handle(startTime)
		},
		reset() {
			this.formModel = {
				ticketIds: '',
				name: '',
				taxNumber: '',
				address: '',
				tele: '',
				depositBank: '',
				bank: '',
				titleType: 2
			}
		}
	},
	created() {}
}
</script>
<style lang="scss" scoped>
.container {
	width: 100%;
	height: 100%;
}
</style>
